 
import { defineComponent, reactive } from 'vue';
import { takeTrade } from "./util/takeTrade";

export default defineComponent({
    setup() {
        const formState = reactive({
            privateKey: "",
            programId: "",
            takerXAccAddress: "",
            takerYAccAddress: "",
            escrowAccAddress: "",
            XTokenExpectedAmount: 0
        })

        const resetUI = () => {
          formState.privateKey = "";
          formState.programId = "";
          formState.takerXAccAddress = "",
          formState.takerYAccAddress = "",
          formState.escrowAccAddress = "",
          formState.XTokenExpectedAmount = 0
        }
        
        const onTakeTrade = async () => {
          try {
            await takeTrade(
              formState.privateKey,
              formState.escrowAccAddress,
              formState.takerXAccAddress,
              formState.takerYAccAddress,
              formState.XTokenExpectedAmount,
              formState.programId
              );
              alert("Success! Alice and Bob have traded their tokens and all temporary accounts have been closed");
          } catch (err) {
            if (err instanceof Error) {
              alert(err.message);
            } else {
              alert("A message-less error occurred");
            }
          }
        }

        return { formState, resetUI, onTakeTrade };
    }
})
